
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.075 9.223h-5.04c-1.517 0-2.758 1.202-2.758 2.689v24.177c0 1.48 1.235 2.69 2.758 2.69h5.04c1.517 0 2.758-1.203 2.758-2.69V11.912c-.006-1.487-1.24-2.69-2.758-2.69zm-5.991 23.589V15.275h2.558v17.537h-2.558zm0 1.863h6.93v1.414c0 .456-.425.826-.945.826h-5.04c-.521 0-.945-.37-.945-.826v-1.414zm6.936-19.4v17.537h-2.558V15.275h2.558zm-6.936-3.363c0-.456.424-.826.945-.826h5.04c.52 0 .945.37.945.826v1.506h-6.93v-1.506zM16.028 10.017l-4.504-.76a2.312 2.312 0 00-1.837.467 2.599 2.599 0 00-.976 1.728L5.526 34.958c-.198 1.442.75 2.8 2.11 3.028l4.504.76c.133.02.261.032.395.032 1.203 0 2.25-.929 2.424-2.228l3.184-23.506c.186-1.436-.761-2.8-2.115-3.027zm.046 6.029l-2.313 17.047-2.29-.39 2.313-17.047 2.29.39zM7.566 32.04l2.313-17.048 2.29.39L9.856 32.43l-2.29-.39zm5.951 2.859l-.186 1.377a.75.75 0 01-.314.513.856.856 0 01-.639.143l-4.504-.76c-.465-.078-.796-.5-.738-.949l.186-1.377 6.195 1.053zm3-22.129l-.198 1.462-6.196-1.053.198-1.461c.058-.442.482-.741.953-.663l4.504.76a.893.893 0 01.575.351.827.827 0 01.163.604zM42.594 9.223a.918.918 0 00-.906.931v.41h-6.93v-.41a.918.918 0 00-.906-.931.918.918 0 00-.907.931v27.692c0 .516.405.932.907.932a.918.918 0 00.906-.931v-.179h6.93v.178c0 .516.405.932.906.932a.918.918 0 00.907-.931V10.153c-.007-.515-.411-.931-.907-.931zm-.906 3.198v23.384h-1.093V12.42h1.093zm-2.9 0v23.384h-1.13V12.42h1.13zm-2.943 0v23.384h-1.093V12.42h1.093z","fill":"#FBBB48"}})])
          )
        }
      }
    